import React from 'react'
import { get } from 'lodash'

import { FilterdCoffees } from '../../utils/filterdCoffees'
import ProductCard from './ProductCard'
import FazendaCard from './FazendaCard'
import { FilterdFazendas } from '../../utils/filterdFazendas'
import ScrollContainer from 'react-indiana-drag-scroll'
// import LazyLoad from 'react-lazyload'
// import { RichText } from 'prismic-reactjs'
// import { linkResolver } from '@prismicio/gatsby-source-prismic-graphql'

const PlpFamilyCountry = ({ data, index, products, toggleSampleForm, lang }) => {

  console.log('[PlpFamilyCountry.js] data', data)

  // const id = useMemo(() => (
  //   get(data, 'primary.id[0].text', '1231232')
  // ), [data])

  let uid, title, description, image, countryClass, filteredCards, counter

  if(data.primary.coffee_family) {

    // For PLP Coffee

    uid = get(data, 'primary.coffee_family._meta.uid')
    title = get(data, 'primary.coffee_family.title[0].text', 'title placeholder')
    description = get(data, 'primary.coffee_family.description[0].text', 'description placeholder')
    image = get(data, 'primary.coffee_family.illustration_couple')
    countryClass = ""
    // filteredCards = FilterdCoffees("family_uid", uid)
    // filteredCards = products
    filteredCards = products.filter(item => item.product.family._meta.uid === uid)

  } else {
    
    // For PLP Fazenda

    uid = get(data, 'primary.country._meta.uid')
    title = get(data, 'primary.country.title[0].text', 'title placeholder')
    description = get(data, 'primary.country.intro[0].text', 'description placeholder')
    image = get(data, 'primary.country.flag')
    countryClass = " plp_family-country"
    filteredCards = FilterdFazendas("country_uid", uid)

    // console.log('[PlpFamilyCountry.js] filteredCards', filteredCards)
    // console.log('[PlpFamilyCountry.js] uid', uid)
  }

  counter = 0
  const renderProductCard = (item, index) => {

    console.log("product", item.product)
    const product = item.product
    const itemLang = get(product, '_meta.lang')
    
    if(itemLang === lang) {
      counter++
      return (<ProductCard item={product} index={counter} key={index} toggleSampleForm={toggleSampleForm} />)
    }
  }

  counter = 0
  // const renderFazendaCard = (item, index) => {
  //   const itemLang = get(item, '_meta.lang')
    
  //   if(itemLang === lang) {
  //     counter++
  //     return <FazendaCard item={item} index={index} key={index} toggleSampleForm={toggleSampleForm} />
  //   }
  // }

  return (
    <section
      key={index}
      className={"plp_family"+countryClass}
      id={'uid-'+uid}>
      <a className="plp_family__anchor" id={uid} href={'#'+uid}>&nbsp;</a>
      <div className="plp_family__header">
        <div className="row">
          <div className="col col6 plp_family__header__col_text">
            <h2 className="special-font plp_family__header__title">
              {title}
            </h2>
            <p className="p-large font-book">
              {description}
            </p>
          </div>
          <div className="col col6 plp_family__header__col_img">
            <img src={image?.url} alt={image?.alt ?? title} />
          </div>
        </div>
      </div>

      <div className="plp_family__slider">

        <ScrollContainer
          className="scroll-container"
          hideScrollbars={false}>

          <div className="plp_family__slider__container">

            {data.primary?.coffee_family ?
              filteredCards && filteredCards?.map((item, index) => renderProductCard(item, index))
            :
              // filteredCards && filteredCards?.map((item, index) => (
              //   <FazendaCard item={item} index={index} key={index} />
              // ))
              filteredCards && filteredCards?.map((item, index) => {
                const itemLang = get(item, '_meta.lang', 'en-us')
                if(itemLang === lang) {
                  return <FazendaCard item={item} index={index} key={index} toggleSampleForm={toggleSampleForm} />
                }
                return null
              })
            }

          </div>
        </ScrollContainer>
        
      </div>
      
    </section>
  )  
}

export default PlpFamilyCountry
